<template>
  <TransitionRoot appear as="template" :show="isOpen">
    <Dialog class="fixed inset-0 overflow-hidden" @close="onClickOutsideHandler">
      <div class="absolute inset-0 overflow-hidden">
        <DialogOverlay class="absolute inset-0" />

        <div class="fixed inset-y-0 right-0 pl-10 max-w-full flex">
          <TransitionChild
            appear
            as="template"
            enter="transform transition ease duration-400 sm:duration-700"
            enter-from="translate-x-full"
            enter-to="translate-x-0"
            leave="transform transition ease-out duration-400 sm:duration-700"
            leave-from="translate-x-0"
            leave-to="translate-x-full">
            <div :class="{ '!max-w-3xl': large }" class="w-screen max-w-md">
              <div
                :class="{ 'h-[70vh] mt-[15vh] shadow-lg rounded-lg': short }"
                class="h-full divide-y divide-gray-200 flex flex-col dark:bg-dark-box-background bg-white shadow-xl">
                <div v-if="show_is_done" class="h-full overflow-y-auto p-2">
                  <!-- if form is submitted successfully -->
                  <slot name="done" :close="close" />
                </div>

                <div v-else class="min-h-0 flex-1 flex flex-col py-6 overflow-visible relative">
                  <div class="px-4 sm:px-6">
                    <div class="flex items-start justify-between">
                      <DialogTitle class="text-xl font-medium dark:text-dark-body-text text-gray-900">
                        <span :class="[{ 'ml-6': titleIcon }]">{{ title }}</span>
                      </DialogTitle>
                      <div class="ml-3 h-7 flex items-center">
                        <button
                          v-if="showXButton"
                          ref="exit_btn_ref"
                          type="button"
                          class="bg-white dark:bg-dark-box-background rounded-md text-gray-400 hover:text-gray-900"
                          @click="close">
                          <span class="sr-only">{{ $t("Close panel") }}</span>
                          <X class="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mt-6 relative flex-1 px-4 pb-24">
                    <!-- The form -->
                    <slot name="form" :close="close" :done="showDoneMsg" />
                  </div>

                  <!-- Footer buttons slot -->
                  <div class="sticky bottom-0 left-0 right-0 border-t bg-white dark:bg-dark-box-background z-50 p-4 shadow-md">
                    <slot name="footer" :close="close" :done="showDoneMsg" />
                  </div>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { X } from "lucide-vue-next"
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from "@headlessui/vue"
export default {
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    X
  },
  props: {
    onClickOutside: {
      type: Function,
      default: null
    },
    titleIcon: {
      type: Boolean,
      default: false
    },
    short: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    showXButton: {
      type: Boolean,
      required: true
    },
    defaultSuccessTitle: {
      type: String,
      default: "Success"
    },
    defaultSuccessMsg: {
      type: String,
      default: ""
    },
    useToast: {
      type: Boolean,
      required: false
    },
    large: null
  },
  emits: ["update:isOpen"],
  data() {
    return {
      show_is_done: false
    }
  },

  methods: {
    onClickOutsideHandler() {
      if (this.onClickOutside) {
        this.onClickOutside()
      } else {
        this.close()
      }
    },
    showDoneMsg() {
      if (this.useToast) {
        this.close()
        this.$toast.open({
          message: `${this.defaultSuccessTitle}\n${this.defaultSuccessMsg}`,
          position: "top",
          type: "success",
          duration: 3000
        })
      } else {
        this.show_is_done = true
        this.$emit("update:isOpen", false)
      }
    },
    close() {
      this.$emit("update:isOpen", false)
      setTimeout(() => {
        this.show_is_done = false
      }, 500)
    }
  }
}
</script>
